<template>
  <div class="view team" :ready="ready">
    <h1>Unser <br>Team</h1>
    <router-link :to="`/about-us/${profile.id}`" class="bio" v-for="(profile, i) in profiles" :active="selected === i" :key="profile.id">
      <div class="bio-container">
        <div class="bio-name">
          <h1 v-html="profile.name.replace(/ /g, '<br>')"></h1>
        </div>
        <div :style="{backgroundImage: `url(${profile.picture})`}" class="profile-picture"></div>
      </div>
    </router-link>
    <button class="ic previous-btn" v-if="selected > 0" @click="selected -= 1">
      <Icon :src="require('@/assets/tr_ic_arrow-left.svg')" />
    </button>
    <button class="ic next-btn" v-if="selected < profiles.length - 1" @click="selected += 1">
      <Icon :src="require('@/assets/tr_ic_arrow-right.svg')" />
    </button>
    <router-link to="/about-us" class="back">&lt; zurück</router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '../components/Icon'

export default {
  name: 'team',
  components: {
    Icon
  },
  data() {
    return {
      profile: null,
      ready: false,
      extended: false,
      selected: -1,
      isMobile: (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  },
  computed: {
    ...mapGetters({
      profiles: 'getProfiles'
    }),
    selectedProfile() {
      return this.profiles[this.selected] || null
    },
  },
  watch: {
    selected(index, previous) {
      if(previous === -1) setTimeout(() => this.ready = true, 160)
      const list = this.$el.querySelectorAll('.bio')
      list.forEach((el, i) => {
        const scale = i === index ? 1 : .82
        const transform = (i - index) * 100
        el.style.transform = `translateX(${transform + (previous !== -1 && i === index ? (index >= previous ? -2 : 2) : 0)}%) scale(${scale})`
        if(previous !== -1 && i === index) {
          setTimeout(() => {
            el.style.transform = `translateX(${transform}%) scale(${scale})`
          }, 160)
        }
      })
    }
  },
  methods: {
    selectProfile(e) {
      clearTimeout(this.scrollTO)
      this.scrollTO = setTimeout(() => {
        if(e.wheelDelta < 0) this.selected = Math.min(this.selected + 1, this.profiles.length - 1)
        else this.selected = Math.max(this.selected - 1, 0)
      }, 150)
    }
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
    if(!this.isMobile) {
      window.addEventListener('mousewheel', this.selectProfile.bind(this))
      this.$nextTick(() => this.selected = 0)
    }
  },
  beforeDestroy: function() {
    if(!this.isMobile) {
      window.removeEventListener('mousewheel', this.selectProfile.bind(this))
    }
  }
}
</script>

<style scoped>
@keyframes bounceBack {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  50% {
    transform: translateX(8px);
    opacity: 1;
  }
  100% {
    transform: none;
    opacity: 1;
  }
}

@keyframes bounceBackReverse {
  0% {
    transform: none;
    opacity: 1;
  }
  50% {
    transform: translateX(8px);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
}

.back {
  position: absolute;
  top: 18.52vh;
  left: 27.6vw;
  font-size: 1.3vh;
  font-weight: 500;
  color: #fff;
  letter-spacing: .4em;
  z-index: 3;
}

button.ic {
  position: absolute;
  top: 42.5vh;
  left: 24.88vw;
  width: 1.66vw;
  height: 1.66vw;
  color: #FFD675;
}

button.ic.next-btn {
  left: auto;
  right: 24.74vw;
}

.bio {
  position: absolute;
  top: 8.15vh;
  left: 27.6vw;
  /* width: 49.27vw; */
  width: 44.8vw;
  height: 72.77vh;
  display: flex;
  justify-content: space-between;
  will-change: transform, opacity;
  transform-origin: bottom center;
  opacity: .46;
  pointer-events: none;
}

.view[ready] .bio {
  transition: transform .16s ease-out, opacity .16s ease-out;
}

.bio .bio-container {
  transition: transform .16s ease-out;
}

.bio[active] {
  opacity: 1;
  pointer-events: all;
}

.bio:before {
  content: '';
  position: absolute;
  top: 12.96vh;
  height: 48.33vh;
  background: rgba(82, 82, 102, .23);
}

.bio:before {
  left: 0;
  width: 44.8vw;
}

.bio[extended]:after {
  width: 43.06vw;
  transform: translateX(-1vw);
}

.bio .profile-picture {
  position: absolute;
  top: 0;
  left: 11.04vw;
  width: 31vw;
  height: 72.77vh;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 0 28px rgba(0,0,0,.5);
  z-index: 1;
  transition: transform .16s ease-out;
  will-change: transform;
}

.bio .profile-picture:after {
  content: '';
  position: absolute;
  bottom: 12px;
  right: 20px;
  width: 24px;
  height: 24px;
  background: url(../assets/tr_ic_large-arrow-right.svg) no-repeat center/contain;
  animation: bounceBackReverse .32s ease-out forwards;
}

@media screen and (min-width: 1025px) {
  .bio .profile-picture:hover {
    transform: scale(1.02);
  }
  .bio .profile-picture:hover:after {
    animation-name: bounceBack;
  }
}

.bio .bio-name,
.bio .bio-quote {
  position: relative;
  flex-shrink: 0;
  z-index: 2;
}

.bio .bio-name {
  width: 19.8vw;
  text-align: right;
  padding-top: 22.22vh;
}

h1,
.bio .bio-name h1 {
  font: 400 2.66vw/1.22 'Exodus Demo St';
  color: #FFD675;
  margin: 0;
}

.view > h1 {
  position: absolute;
  top: 37vh;
  left: 10.83vw;
  z-index: 2;
}

.bio .bio-name .bio-description {
  font-weight: 300;
  line-height: 1.875;
  letter-spacing: .05em;
  margin-bottom: 1.48vh;
  height: 16.11vh;
}

.bio .bio-name .bio-socials {
  margin-top: 3.33vh;
}

.bio .bio-name .bio-socials a {
  position: relative;
  display: inline-flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  margin-left: .625vw;
}

.bio .bio-name .bio-socials a .tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  border: 1px solid rgba(255, 214, 117, 0.23);
  padding: 8px 16px;
  white-space: nowrap;
  font-size: 1.3vh;
  opacity: 0;
  transition: opacity .16s;
  pointer-events: none;
}

.bio .bio-name .bio-socials a:hover .tooltip {
  opacity: 1;
  pointer-events: all;
}

.bio .bio-name .bio-socials a .tooltip:after,
.bio .bio-name .bio-socials a .tooltip:before {
	bottom: 100%;
	left: 88%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
}

.bio .bio-name .bio-socials a .tooltip:after {
	border-color: transparent;
	border-bottom-color:#0A1612;
	border-width: 6px;
	margin-left: -6px;
}

.bio .bio-name .bio-socials a .tooltip:before {
	border-color: transparent;
	border-bottom-color: rgba(255, 214, 117, 0.23);
	border-width: 7px;
	margin-left: -7px;
}

.bio .bio-quote {
  width: 32.5vw;
  color: #FFD675;
  font-weight: 300;
  align-self: flex-end;
  margin-bottom: 39.07vh;
}

.bio .bio-quote .bio-quote-text {
  font-style: italic;
  font-size: 1.04vw;
  letter-spacing: .2em;
  line-height: 1.35;
}

.bio .bio-quote .bio-quote-author {
  padding-right: 10.94vw;
  text-align: right;
  margin-top: 1.85vh;
  letter-spacing: .05em;
}

.bio .bio-quote .bio-quote-author:after {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 2px;
  background: #FFD675;
  margin-left: 22px;
}

.bio .bio-content {
  width: 25.47vw;
  padding-top: 15.4vh;
  font-weight: 300;
  line-height: 1.875;
  letter-spacing: .05em;
  padding-right: 1.2vw;
}

.bio .bio-content >>> p {
  margin: 0 0 2.96vh;
}

@media screen and (max-width: 1024px) {
  .view > h1 {
    position: relative;
    top: auto;
    left: auto;
    text-align: center;
    font-size: 34px;
    margin-bottom: 76px;
  }
  .back,
  .view > h1 br,
  button.ic,
  .bio .profile-picture:after {
    display: none;
  }
  .bio {
    position: relative;
    display: block;
    width: auto;
    top: auto;
    left: auto;
    height: auto;
    padding: 0 30px;
    transform: none !important;
    opacity: 1;
    margin: 82px 0 0;
    pointer-events: all;
  }
  .bio[active] {
    margin: 0;
  }
  .bio:before {
    top: 52px;
    bottom: 52px;
    left: 30px;
    right: 30px;
    width: auto;
    height: auto;
  }
  .bio .profile-picture {
    position: relative;
    left: auto;
    width: 70%;
    margin: 0 24px 0 auto;
    height: auto;
    padding-top: 92%;
  }
  .bio .bio-name {
    position: absolute;
    width: auto;
    padding: 0;
    top: 68px;
    right: 55%;
  }
  .bio .bio-name h1 {
    font-size: 22px;
  }
}
</style>

